import { render, staticRenderFns } from "./ProductsProduct.vue?vue&type=template&id=7393add3&"
import script from "./ProductsProduct.vue?vue&type=script&lang=js&"
export * from "./ProductsProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports